
import BankDashboard from "components/ManageBank/BankDashboard";
import NotFooterLayout from "layouts/NotFooterLayout";
import { useParams } from "react-router-dom";


function BankDashboardPage() {
  const { id } = useParams<{ id: string }>();

  return (
    <NotFooterLayout namePage="ข้อมูลบัญชี" >
      <div className="layout-content">
        <BankDashboard id={id ?? ''} />
      </div>
    </NotFooterLayout>
  );
}

export default BankDashboardPage;